import router, {resetRouter, constantRoutes, dynamicRoutes} from '../../router'
import axios from '../../assets/js/httpConfig/http'

import {fileUrl} from '../../../static/config/config'
import {login} from "../../api/user";
import store from "../index";

function getLocalStorageAsJson(key, defVal) {
  try {
    const item = window.localStorage.getItem(key)
    if (item) {
      return JSON.parse(item)
    }
  } catch (e) {
  }
  return defVal
}

const getDefaultState = () => {
  return {
    token: window.sessionStorage.getItem("token"),
    userId: window.sessionStorage.getItem("userId"),
    fullname: window.localStorage.getItem('fullname'),
    username: window.localStorage.getItem('username'),
    roleName: window.localStorage.getItem('roleName'),
    roleCode: window.localStorage.getItem('roleCode'),
    institutionId: window.localStorage.getItem('institutionId'),
    logo: window.localStorage.getItem('logo'),
    permissions: getLocalStorageAsJson('permissions', []),
    isAdmin: false,
    menu: [],
    //
    fileUrl: fileUrl,
  }
}

/**
 * 判断是否有路由权限
 * @param perms
 * @param route
 * @returns {*|boolean}
 */
function hasPermission(perms, route) {
  if (perms.includes('ROLE_ADMIN')) {
    return true;
  }
  if (route.meta && route.meta.perms) {
    const metaPerms = route.meta.perms
    const list = metaPerms.split(',');
    return perms.some(perm => {
      return list.includes(perm);
    });
  }
  return true;
}

function filterAsyncRoutes(routes, perms) {
  const res = [];
  routes.forEach(route => {
    const tmp = {...route}
    if (hasPermission(perms, tmp)) {
      if (tmp.children && tmp.children.length > 0) {
        tmp.children = filterAsyncRoutes(tmp.children, perms);
        if (tmp.children && tmp.children.length > 0) {
          res.push(tmp);
        }
      } else {
        res.push(tmp);
      }
    }
  });
  return res;
}

/**
 * 格式化路由为MenuTree
 * @param parent
 * @param routes
 * @returns {*[]}
 */
function formatRoutesAsMenu(parent, routes) {
  if (parent) {
    parent['hasChildren'] = false
  }
  const list = []
  for (const route of routes) {
    if (route.parent !== parent) {
      continue
    }
    if (parent) {
      parent['hasChildren'] = true
    }
    if (route.meta && route.meta.hidden) {
      continue
    }
    const children = formatRoutesAsMenu(route, routes)
    if (children && children.length > 0) {
      route['children'] = children
      list.push(route)
    } else if (!route['hasChildren']) {
      list.push(route)
    }
  }
  return list;
}

const state = getDefaultState()
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    window.sessionStorage.setItem("token", token);
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
    window.sessionStorage.setItem("userId", userId);
  },
  SET_FULLNAME: (state, fullname) => {
    state.fullname = fullname
    window.localStorage.setItem('fullname', fullname)
  },
  SET_ROLENAME: (state, roleName) => {
    state.roleName = roleName
    window.localStorage.setItem('roleName', roleName)
  },
  SET_USERNAME: (state, username) => {
    state.username = username
    window.localStorage.setItem('username', username)
  },
  SET_ROLECODE: (state, roleCode) => {
    state.roleCode = roleCode
    window.localStorage.setItem('roleCode', roleCode)
  },
  SET_INSTITUTIONID: (state, institutionId) => {
    state.institutionId = institutionId
    window.localStorage.setItem('institutionId', institutionId)
  },
  SET_LOGO: (state, logo) => {
    state.logo = logo
    window.localStorage.setItem('logo', logo)
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
    window.localStorage.setItem('permissions', JSON.stringify(permissions || []))
  },
  SET_ISADMIN: (state, isAdmin) => {
    state.isAdmin = isAdmin
  },
  SET_MENU: (state, menu) => {
    state.menu = Array.isArray(menu) ? menu : []
  },
  // 其他
  // RESET_STATE: (state) => {
  //   Object.assign(state, getDefaultState())
  // },
}
const actions = {
  /**
   * 用户登录
   * @param commit
   * @param userInfo
   * @returns {Promise}
   */
  login({commit}, userInfo) {
    const {username, password} = userInfo
    return new Promise((resolve, reject) => {
      login(username, password).then(res => {
        const {data} = res.data;
        console.log('data:', data)
        commit('SET_TOKEN', data.token);
        commit('SET_USERID', data.personInfo.id);
        commit('SET_FULLNAME', data.personInfo.fullname);
        commit('SET_ROLENAME', data.personInfo.roleName);
        commit('SET_USERNAME', data.personInfo.username);
        commit('SET_ROLECODE', data.personInfo.roleCode);
        commit('SET_INSTITUTIONID', data.personInfo.institutionId);
        commit('SET_PERMISSIONS', data.authorities);
        commit('SET_MENU', [])
        commit('SET_LOGO', data.sysInstitution.logo || '');
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 初始化路由和目录
   * @param commit
   * @returns {Promise<unknown>}
   */
  initMenu({commit}) {
    return new Promise((resolve, reject) => {
      // 格式化路由
      const userRoutes = filterAsyncRoutes(dynamicRoutes, store.getters.permissions)
      router.matcher.addRoutes(userRoutes)

      // 判断是否是系统管理员
      commit('SET_ISADMIN', store.getters.userId + '' === '1')

      // 格式化MenuTree
      const menu = formatRoutesAsMenu(undefined, router.getRoutes())
      commit('SET_MENU', menu);
      resolve()
    })
  },
  // user logout
  logout({commit, state}) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', null)
      commit('SET_USERID', null)
      commit('SET_FULLNAME', null)
      commit('SET_ROLENAME', null)
      commit('SET_USERNAME', null)
      commit('SET_ROLECODE', null)
      commit('SET_INSTITUTIONID', null)
      commit('SET_LOGO', null)
      commit('SET_PERMISSIONS', null)
      commit('SET_MENU', [])

      resetRouter()
      window.sessionStorage.clear();
      window.localStorage.clear();
      router.push({
        path: "/login"
      });
      // axios.get('/admin/out?name=' + state.username)
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js